import app from "flarum/app";
import openPreferredTagsModal from './actions/openPreferredTagsModal';
import addPreferredTagsUIChanges from './actions/addPreferredTagsUIChanges';

app.initializers.add('netcompany-preferred-tags', () => {
  addPreferredTagsUIChanges();
  openPreferredTagsModal();
});
